export enum FlightShopTrackingEventName {
  // Fired when loading screen appears between calendar and flight list
  viewed_flight_shop_loading = "viewed_flight_shop_loading",

  // Fired when a user lands on the flight list page
  viewed_flight_list = "viewed_flight_list",

  // Fired when the price prediction component is available
  viewed_forecast = "viewed_forecast",

  // Fired when a user adds a filter onto the search results
  applied_filter = "applied_filter",

  // Fired when a user taps into view a specific flight and fare classes available
  viewed_slice = "viewed_slice",

  // When a user selects a particular fare for an outbound/return flight and hits continue
  selected_flight = "selected_flight",

  // Fired when a user lands on the view itinerary page after selecting flight(s) to review them.
  viewed_trip_summary = "viewed_trip_summary",

  // Fired when a user lands on the fare details page to review amenities includes on flight
  viewed_amenity_review = "viewed_amenity_review",
}
